import React from "react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Text } from "@chakra-ui/react";
import { Link } from "react-router";
import { useBreadcrumbs } from "../../contexts/BreadcrumbProvider";

export const BreadcrumbNavs = () => {
    const { breadcrumbs, removeBreadcrumb } = useBreadcrumbs();

    return (
        <Breadcrumb spacing="8px" separator="/" sx={{ margin: "0 0 20px" }}>
            {breadcrumbs?.map(({ label, path }, index) => {
                const isLast = index === breadcrumbs.length - 1;

                return (
                    <BreadcrumbItem key={path} isCurrentPage={isLast}>
                        {isLast ? (
                            <Text opacity="0.7">{label}</Text>
                        ) : (
                            <BreadcrumbLink
                                as={Link}
                                to={path}
                                onClick={() => removeBreadcrumb(path === "/" ? 0 : index + 1)}
                                opacity="0.7"
                            >
                                {label}
                            </BreadcrumbLink>
                        )}
                    </BreadcrumbItem>
                );
            })}
        </Breadcrumb>
    );
};
